import { Link } from "design-system/components/primitives/link/link";

import { MediaAssetImageProps } from "design-system/components/primitives/media-asset/media-asset-image";
import { MediaAsset } from "design-system/components/primitives/media-asset/media-asset";

export interface ArticleFooterLinkedAuthorProps {
  name: string;
  href?: string;
  titles?: Array<string>;
  bio?: string;
  image?: MediaAssetImageProps;
}

export function ArticleFooterLinkedAuthor({
  name,
  href,
  titles,
  bio,
  image,
}: ArticleFooterLinkedAuthorProps) {
  return (
    <address className="hbs-article-footer__linked-author">
      <div className="hbs-article-footer__linked-author__content">
        <strong>{href ? <Link href={href}>{name}</Link> : name}</strong>
        {titles?.length && <span>, {titles.join(", ")}</span>}
        <br />
        {bio && (
          <>
            {bio}
            <br />
          </>
        )}
      </div>
      {image && (
        <div className="hbs-article-footer__linked-author__image">
          <MediaAsset image={image} aspectRatio="1/1" />
        </div>
      )}
    </address>
  );
}
